<p-toast></p-toast>
<div>
    <div class="own-mi-farmer-details card" #targetTable>
        <form [formGroup]="newRegForm" (ngSubmit)="onSubmitfarmerOwnMIDetails()">
            <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Submit Aadhar No for e-KYC' | translate }}</p>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
                    <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo"
                        pInputText id="block" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': newRegForm.controls['aadharNo'].invalid && newRegForm.controls['aadharNo'].touched }" />

                    <div *ngIf="newRegForm.controls['aadharNo'].invalid && newRegForm.controls['aadharNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="newRegForm.controls['aadharNo'].errors.required">
                            {{'AADHAR_NO_IS_REQUIRED'
                            | translate}}</div>
                        <div *ngIf="newRegForm.controls['aadharNo'].errors.minlength">
                            {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                        <div *ngIf="newRegForm.controls['aadharNo'].errors.maxlength">
                            {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                        <!-- <div *ngIf="newRegForm.controls['aadharNo'].errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' |
                    translate}}</div> -->
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="component">{{'PV Assign To'| translate}}</label>
                    <p-dropdown [options]="jeList" formControlName="je"
                        placeholder="{{ 'Next User'| translate }}" optionLabel="UserID" optionValue="UserID" class="mr-3">
                    </p-dropdown>
                    <div *ngIf="newRegForm.controls['je'].invalid && newRegForm.controls['je'].touched"
                        class="invalid-feedback">
                        <div *ngIf="newRegForm.controls['je'].errors.required">{{'Next user is required' |
                            translate}}</div>
                    </div>
                </div> -->

                <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="component">{{'Remarks'| translate}}</label>
                    <textarea id="description" formControlName="remarks" placeholder="Remarks" pInputTextarea required
                        rows="2" cols="20" class="mr-3"></textarea>
                    <div *ngIf="newRegForm.controls['remarks'].invalid && newRegForm.controls['remarks'].touched"
                        class="invalid-feedback">
                        <div *ngIf="newRegForm.controls['remarks'].errors.required">{{'Remarks is required' |
                            translate}}</div>
                    </div>
                </div> -->

                <!-- <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{'UHBVN Request Letter for NOC' | translate}}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerBillDocUpload
                        (uploadHandler)="onBillUpload($event, 'nocPath', farmerBillDocUpload)" name="myfile[]"
                        [maxFileSize]="5000000" [multiple]="false" chooseLabel="{{'CHOOSE'| translate}}" [auto]="false"
                        [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <p-image *ngIf="newRegForm.controls['nocPath'].value"
                                [src]="newRegForm.controls['nocPath'].value" alt="Image" width="60"
                                class="ml-2" iconPos="left"></p-image>
                            <ul *ngIf="uploadedAadharFiles.length">
                            <li *ngFor="let file of uploadedAadharFiles">
                                <p-image *ngIf="newRegForm.controls['aadharPhotoPath'].value"
                                    [src]="newRegForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul>
                        </ng-template>
                    </p-fileUpload>
                    <div *ngIf="newRegForm.controls['nocPath'].invalid && newRegForm.controls['nocPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="newRegForm.controls['nocPath'].errors.required">
                            {{'BILL_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div> -->

                <div class="field col-12 md:col-4 button-container-submit">
                    <label></label>
                    <div class="grid-item">
                        <button pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
                            class="p-button-success mt-2 ml-5" style="width: 100px; height: 35px; align-items: center;">
                        </button>

                        <!-- <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
                                style="width: 100px; height: 32px; align-items: center;">
                            </button> -->
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>


<p-dialog [(visible)]="showKYCPopUpDialog" [style]="{width: '650px'}" header="{{ 'Complete KYC' | translate}}"
  [modal]="true" [baseZIndex]="-100" styleClass="p-fluid" (onHide)="hideKYCDialog()">
  <app-kyc *ngIf="showKYCPopUpDialog && farmerData" [farmerDetails]="farmerData" (newItemEvent)="addItem($event)"></app-kyc>
  <!-- <ng-template pTemplate="content">
  </ng-template> -->

  <!-- <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text" (click)="hidePPIDDialog()"></button>
  </ng-template> -->
</p-dialog>